export default "__VITE_ASSET__7f2b6b9a__"